import {
  AccountClient,
  GET_NEW_IN_APP_NOTIFICATIONS_COUNT
} from '@nile/graphql/src';
import { useCallback, useEffect, useRef, useState } from 'react';
import envConfig from '@nile/home/src/Config/env';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useQuery } from '@apollo/client';

let broadcastChannel;
if (BroadcastChannel) {
  broadcastChannel = new BroadcastChannel('SuperShare');
}

export function useInAppNotificationsCount() {
  const [count, setCount] = useState(null);
  const flags = useFlags();
  const audioRef = useRef(null);

  const handleVisibilityChange = () => {
    if (flags?.testWebSocketConnection) {
      console.log(`Tab state : ${document.visibilityState}`);
      if (document.visibilityState === 'visible') {
        broadcastChannel.postMessage(
          JSON.stringify({
            name: 'wsdata',
            data: {
              context: 'heartbeat',
              action: {
                name: 'heartbeat'
              }
            }
          })
        );
      }
    }
  };

  useEffect(() => {
    document.addEventListener('visibilitychange', handleVisibilityChange);
    return function cleanup() {
      document.removeEventListener('visibilityChange', handleVisibilityChange);
    };
  }, []);

  // if (audioRef.current === null) {
  //   audioRef.current = new Audio(`/audio/in-app-notification-sound.mp3`);
  // }

  const resetNotificationsCount = useCallback(() => {
    setCount(null);
  }, []);

  const { data: notificationsCount } = useQuery(
    GET_NEW_IN_APP_NOTIFICATIONS_COUNT,
    {
      client: AccountClient
    }
  );

  function playNotificationTone() {
    // eslint-disable-next-line no-unused-expressions
    audioRef.current?.play();
  }

  useEffect(() => {
    setCount(notificationsCount?.getNewInAppNotificationsCount);
  }, [notificationsCount]);

  broadcastChannel.onmessage = (event) => {
    // console.log(event?.data);
    if (event.data) {
      const eventData = JSON.parse(event.data);
      if (eventData.context === 'InAppNotification') {
        if (flags?.playNotificationSound) {
          playNotificationTone();
        }
        setCount(eventData.payload.newNotificationCount);
      }
    }
  };

  return { count, resetNotificationsCount };
}
